//平台api查询的前缀
import {AssertUtils,GoingUtils} from "goingutils";


let GoTabUrl={
    //获取所有单位
    queryAllAccounts:`${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/component/allTenant`,
    //查询所有用户
    queryAllUser: `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/component/allUser`,
    //根据岗位id获取用户信息
    getUserByStationId(stationId) {
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/users/getUsersByStation/` + stationId;
    },
    //查询岗位信息 unitAdmin
    queryStationByAccount(accountId) {
        if(!AssertUtils.isNotEmpty(accountId)){
            accountId="supperAccount";
        }
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/station/queryStationByAccountId/` + accountId;
    },
    //保存最近使用人信息
    getCurUserRecentUsers: `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/component/getRecentUsers`,
    //根据账套id 获取当前账套下的 编外单位信息
    getOutUnitByAccountId(accountId){
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/extraUnit/queryOutUnitByAccountId/` + accountId;
    },
    getUserByJobLevelId(accountId) {
        return  `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/component/getUserByJobLevelId/` + accountId;
    },
    //根据groupId获取该群组下的组员信息
    loadUsersByGroupId(recordId) {
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/userGroup/loadUsersByGroupId/` + recordId;
    },
    //获取角色下的用户信息
    getUserByRoleId(roleId) {
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/component/getUserByRoleId/` + roleId;
    },
    //根据账套id 获取该账套下的角色信息
    queryRoleByAccountId(accountId) {
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/component/readRoles/` + accountId;
    },
    //根据编外单位查询该单位下的编外人员信息
    queryOutUserByOutUnitId(outUnitId) {
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/extraUser/queryOutUserByOutUnitId/` + outUnitId;
    },
    //根据账套查询该账套下的外单位信息
    queryOutUnitByAccountId(accountId) {
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/extraUnit/queryOutUnitByAccountId/` + accountId;
    },
    /**
     * 根据账套id 获取该账套下的职务级别信息
     * @param accountId
     */
    queryJobLevelByAccountId(accountId) {
        if(!AssertUtils.isNotEmpty(accountId)){
            accountId="supperAccount";
        }
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/jobLevel/queryJobLevelByAccountId/` + accountId;
    },
    //根据账套id 获取部门树信息
    getOrgTreeByAccountId(accountId) {
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/dept/getOrgsByAccountId/` + accountId;
    },
    //根据部门id获取用户信息
    getUserByOrgId(orgId) {
        if(!AssertUtils.isNotEmpty(orgId)){
            GoingUtils.showErrorMessage("请选择相应机构后再进行查询！");
            return void(0);
        }
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/users/getUserByOrgId/` + orgId;
    },
    //根据单位id获取该单位可以查看的群组信息
    loadUserGroupByAccountId(recordId) {
        return `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/userGroup/loadUserGroupByAccountId/` + recordId;
    }
};

export default  GoTabUrl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/goTabsUrl.js